/* tslint:disable */
/* eslint-disable */
/**
 * Procon BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ManufacturingRequestDto
 */
export interface ManufacturingRequestDto {
    /**
     * 
     * @type {string}
     * @memberof ManufacturingRequestDto
     */
    articleNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof ManufacturingRequestDto
     */
    hardwareRevision?: number;
    /**
     * 
     * @type {number}
     * @memberof ManufacturingRequestDto
     */
    amountOfDevices?: number;
    /**
     * OemIds are mapped as follows:
     * <ul>
     *  <li>0 = Default/Liebherr</li>
     *  <li>1 = Liebherr_Consumer</li>
     *  <li>2 = Liebherr_B/I</li>
     *  <li>3 = Miele_Consumer</li>
     *  <li>4 = VZUG_Consumer</li>
     *  <li>5 = Bora_Consumer</li>
     *  <li>6 = Landig_GameCooler</li>
     *  <li>7 = Landig_DryAger</li>
     *  <li>8 = Wepa</li>
     * </ul>
     * @type {number}
     * @memberof ManufacturingRequestDto
     */
    oemId?: number;
    /**
     * Connectivity module type of the batch (CM006, CM008, CM015). Required. Landig oemIds 6 and 7 use CM006.
     * @type {string}
     * @memberof ManufacturingRequestDto
     */
    moduleType: ManufacturingRequestDtoModuleTypeEnum;
}


/**
 * @export
 */
export const ManufacturingRequestDtoModuleTypeEnum = {
    Cm006: 'CM006',
    Cm008: 'CM008',
    Cm015: 'CM015'
} as const;
export type ManufacturingRequestDtoModuleTypeEnum = typeof ManufacturingRequestDtoModuleTypeEnum[keyof typeof ManufacturingRequestDtoModuleTypeEnum];


/**
 * Check if a given object implements the ManufacturingRequestDto interface.
 */
export function instanceOfManufacturingRequestDto(value: object): value is ManufacturingRequestDto {
    if (!('moduleType' in value) || value['moduleType'] === undefined) return false;
    return true;
}

export function ManufacturingRequestDtoFromJSON(json: any): ManufacturingRequestDto {
    return ManufacturingRequestDtoFromJSONTyped(json, false);
}

export function ManufacturingRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManufacturingRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'articleNumber': json['articleNumber'] == null ? undefined : json['articleNumber'],
        'hardwareRevision': json['hardwareRevision'] == null ? undefined : json['hardwareRevision'],
        'amountOfDevices': json['amountOfDevices'] == null ? undefined : json['amountOfDevices'],
        'oemId': json['oemId'] == null ? undefined : json['oemId'],
        'moduleType': json['moduleType'],
    };
}

export function ManufacturingRequestDtoToJSON(json: any): ManufacturingRequestDto {
    return ManufacturingRequestDtoToJSONTyped(json, false);
}

export function ManufacturingRequestDtoToJSONTyped(value?: ManufacturingRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'articleNumber': value['articleNumber'],
        'hardwareRevision': value['hardwareRevision'],
        'amountOfDevices': value['amountOfDevices'],
        'oemId': value['oemId'],
        'moduleType': value['moduleType'],
    };
}

